module.exports = __webpack_public_path__ + "fonts/payback_regular-webfont.4d99c97d.eot";